import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { DataEmptyAnimationComponent } from '../../animations/data-animations/data-empty-state/data-empty-animation.component';

@Component({
  selector: 'app-flight-primary-data',
  standalone: true,
  imports: [SvgLoaderComponent, CommonModule, DataEmptyAnimationComponent],
  templateUrl: './flight-primary-data.component.html',
  styleUrl: './flight-primary-data.component.scss'
})
export class FlightPrimaryDataComponent {
  @Input() label: string = '';
  @Input() value: string = null;
  @Input() icon: string = null;

  iconURL: string = '';

  ngOnInit() {
    if (this.icon) {
      const url = `assets/svg/${this.icon}`;
      this.iconURL = url;
    }
  }
}
